<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-wifi-off`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M5.615 2.787l39.598 39.598a1 1 0 010 1.414L43.8 45.213a1 1 0 01-1.414 0L2.787 5.615a1 1 0 010-1.414L4.2 2.787a1 1 0 011.414 0zM24.037 35a3 3 0 012.591 1.486l-2.59 2.59-2.591-2.59A2.999 2.999 0 0124.037 35zm-4.31-8.203l3.27 3.27a7.989 7.989 0 00-5.129 2.84l-2.837-2.837a12.023 12.023 0 014.696-3.273zm5.373-8.77a19.95 19.95 0 0113.608 6.379l-2.832 2.83a16.04 16.04 0 00-5.499-3.93L25.1 18.027zm-11.335 2.809l2.94 2.94a16.06 16.06 0 00-4.506 3.46l-2.831-2.83a20.092 20.092 0 014.397-3.57zM24.038 9c8.281 0 15.752 3.472 21.036 9.039l-2.829 2.83C37.685 16.023 31.215 13 24.038 13c-1.256 0-2.49.092-3.696.271l-3.398-3.397A29.06 29.06 0 0124.038 9zM7.267 14.338l2.875 2.876a25.129 25.129 0 00-4.312 3.654L3 18.038a29.158 29.158 0 014.267-3.7z"/></svg>
</template>
<script>

export default {
  name: 'IconWifiOff',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
